import { AloftPrice, AloftPriceJSON } from '@aloft/shared-objects';
import { CompType } from '@aloft/toolkit-shared';

export const getDepreciationRowLabel = (index: number) => (index === 0 ? 'SUB' : `CP ${index}`);

export const calculateDifferenceInDepreciation = (
  subjectDepreciation?: AloftPriceJSON,
  compDepreciation?: AloftPriceJSON,
) => {
  if (!subjectDepreciation || !compDepreciation) return undefined;

  return AloftPrice.schema
    .parse(subjectDepreciation)
    .sub(AloftPrice.schema.parse(compDepreciation));
};

export const getDepreciationDifferenceString = (depreciationDifference?: AloftPrice | string) => {
  if (!depreciationDifference) return '-';

  if (typeof depreciationDifference === 'string') return depreciationDifference;
  return depreciationDifference.toString(true);
};

export const isAivRow = (row: { id: string }, compTypes: { [key: string]: CompType | undefined }) => {
  if (row.id === 'subject') return true;
  if (row.id === 'subjectArv') return false;

  return !compTypes[row.id] || compTypes[row.id] === 'aiv';
}

export const isArvRow = (row: { id: string }, compTypes: { [key: string]: CompType | undefined }) => {
  if (row.id === 'subject') return false;
  if (row.id === 'subjectArv') return true;

  return compTypes[row.id] === 'arv';
}
